import { Action, createReducer, on } from '@ngrx/store';
import * as IntegrationsActions from '../actions/integrations.actions';

export const integrationsFeatureKey = 'integrations';

export interface State {
  hasQuickBooks: Boolean
}

export const initialState: State = {
  hasQuickBooks: null
};

export const reducer = createReducer(
  initialState,

  on(IntegrationsActions.loadIntegrations, state => state),
  on(IntegrationsActions.loadIntegrationsSuccess, (state, action) => state),
  on(IntegrationsActions.loadIntegrationsFailure, (state, action) => state),
  on(IntegrationsActions.toggleQuickBooks, (state, action) => ({
    ...state,
    hasQuickBooks: action.active
  })),

);